// extracted by mini-css-extract-plugin
module.exports = {"rich":"rich_rich__HobIA","alt":"rich_alt__47vHJ"};